<template>
    <div class="nav hidden-xs">
        <ul>
            <li v-for="tab in headerTabs" id="menu_{tab.name}" @click.prevent="setActiveHeaderTabName(tab)" class="navbar-item" v-bind:class="{active : displayHeaderName(tab.name)}">
                {{ tab.displayName}}
            </li>
        </ul>
    </div>
</template>

<script>
import router from '../../router'
import { mapState } from 'vuex'
import Cookies from 'js-cookie'

export default {    
    data () {
        return {
            headerTabs: [
                {
                    name: 'compliances',
                    displayName: 'Compliance'
                },
                {
                    name: 'requests',
                    displayName: 'Jobs'
                },
            ],
        }
    },
    computed: {
        ...mapState('nav', {
            activeHeaderTabName: state => state.activeHeaderTab
        })
    },

    methods: {
        setActiveHeaderTabName(tab) {
            //console.log("name", tab.name)
            //this.activeHeaderTabName = tab.name;
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeHeaderTab',
                    value: tab.name
                }
            )
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeHeaderDisplayName',
                    value: tab.displayName
                }
            )
            
            // push to welcome page when 'Home' is pressed.
            if(tab.name === 'compliances'){
                router.push({name: 'items', params: { items: 'welcome' }, query: { id: '1', display_name: 'Welcome' } })
                VueStore.dispatch('compliance/getCompliance', 1);
                Cookies.set('ROUTE_ID', 1)
            } else {
                router.push({name: 'requests'})
            }
        },

        displayHeaderName(name) {
            return this.activeHeaderTabName === name;
        },
    },

    created (){
        // Check local storage for active tab otherwise use 1st item in the tabs array
        if( (typeof sessionStorage.getItem("ACTIVE-HEADER-TAB") !== 'undefined') && (sessionStorage.getItem("ACTIVE-HEADER-TAB") !== null)){
            //this.activeHeaderTabName = sessionStorage.getItem("ACTIVE-HEADER-TAB");
            //this.activeHeaderDisplayName = sessionStorage.getItem("ACTIVE-HEADER-DISPLAY-NAME");

            // Set vuex again on a refresh
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeHeaderTab',
                    value: sessionStorage.getItem("ACTIVE-HEADER-TAB")
                }
            )
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeHeaderDisplayName',
                    value: sessionStorage.getItem("ACTIVE-HEADER-DISPLAY-NAME")
                }
            )
        } else {
            // define the default
            var tabName = 'requests';
            var displayName = 'Requests';

            //this.activeHeaderTabName = tabName;
            //this.activeHeaderDisplayName = displayName;
            // Set vuex on initial load
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeHeaderTab',
                    value: tabName
                }
            )
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeHeaderDisplayName',
                    value: displayName
                }
            )
        }
    },

    mounted(){

    }
}
</script>

<style scoped>

</style>